export enum MethodClaimObjectAdditionCodeEnum {
    Automatic = 'Automatic',
    Manually = 'Manually',
}
